"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconNewWindow', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M4 2C4 1.44772 4.44772 1 5 1H14C14.5523 1 15 1.44772 15 2V11C15 11.5523 14.5523 12 14 12H12V14C12 14.5523 11.5523 15 11 15H2C1.44772 15 1 14.5523 1 14V5C1 4.44772 1.44772 4 2 4H4V2ZM6 4V10H13V4H6ZM5 12H10V13H3V6H4V11C4 11.5523 4.44772 12 5 12Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M5 2C5 1.44772 5.44772 1 6 1H18C18.5523 1 19 1.44772 19 2V14C19 14.5523 18.5523 15 18 15H15V18C15 18.5523 14.5523 19 14 19H2C1.44772 19 1 18.5523 1 18V6C1 5.44772 1.44772 5 2 5H5V2ZM7 5V13H17V5H7ZM6 15H13V17H3V7H5V14C5 14.5523 5.44772 15 6 15Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M6.03009 1C5.47781 1 5.03009 1.44772 5.03009 2V6H2.03009C1.47781 6 1.03009 6.44772 1.03009 7V22C1.03009 22.5523 1.47781 23 2.03009 23H18.0301C18.5824 23 19.0301 22.5523 19.0301 22V19H22.0301C22.5824 19 23.0301 18.5523 23.0301 18V2C23.0301 1.44772 22.5824 1 22.0301 1H6.03009ZM7.03009 6V17H21.0301V6H7.03009ZM17.0301 19V21H3.03009V8H5.03009V18C5.03009 18.5523 5.47781 19 6.03009 19H17.0301Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M9.49988 2C8.67145 2 7.99988 2.67157 7.99988 3.5V7.00012H3.49988C2.67145 7.00012 1.99988 7.67169 1.99988 8.50012V28.5001C1.99988 29.3285 2.67145 30.0001 3.49988 30.0001H23.4999C24.3283 30.0001 24.9999 29.3285 24.9999 28.5001V25H28.4999C29.3283 25 29.9999 24.3284 29.9999 23.5V3.5C29.9999 2.67157 29.3283 2 28.4999 2H9.49988ZM10.9999 8H26.9999V22H10.9999V8ZM21.9999 25H9.49988C8.67145 25 7.99988 24.3284 7.99988 23.5V10.0001H4.99988V27.0001H21.9999V25Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;